import * as React from 'react';

export function SvgCamBubbleSmall(props: any) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <circle cx={12} cy={12} r={6} fill="currentColor" />
    </svg>
  );
}
